
namespace Matrix.Data {

    @Serenity.Decorators.registerEditor()
    export class AlignmentStringEditor extends Serenity.Select2Editor<any, any> {

        constructor(element: JQuery) {
            super(element);

            this.addOption("left", "Left");
            this.addOption("right", "Right");
            this.addOption("center", "Center");
        }
    }
}